import type { IntlShape } from 'react-intl'

export function resolveLocalizedConfigValue(
  intl: Pick<IntlShape, 'formatMessage'>,
  value: App.I18nMessageDescriptor | string,
) {
  return typeof value === 'string' ? value : intl.formatMessage(value)
}
